/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Fleet_TitleInputs */

const vi_station_fleet_title = /** @type {(inputs: Station_Fleet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định vị & camera`)
};

/**

* @param {Station_Fleet_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_fleet_title = /** @type {((inputs?: Station_Fleet_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Fleet_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_fleet_title(inputs)
});